import { render } from "./attestation.vue?vue&type=template&id=12ea2bbc&scoped=true"
import script from "./attestation.vue?vue&type=script&lang=js"
export * from "./attestation.vue?vue&type=script&lang=js"

import "./attestation.vue?vue&type=style&index=0&id=12ea2bbc&lang=scss&scoped=true"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ea2bbc"]])

export default __exports__